export const trustBadges = [
  {
    icon: 'ri-timer-flash-line',
    title: '最短即日対応',
    desc: '急なご依頼にも迅速対応',
  },
  {
    icon: 'ri-shield-check-line',
    title: '許可業者',
    desc: '産廃・一般廃棄物収集運搬業の許可を取得',
  },
  {
    icon: 'ri-file-list-3-line',
    title: '追加料金なしの明朗会計',
    desc: 'お見積り後の追加料金は一切ありません',
  },
  {
    icon: 'ri-building-2-line',
    title: '法人・不動産会社対応',
    desc: '法人様・不動産会社様からのご依頼も多数対応',
  },
];

export const reasons = [
  {
    num: '01',
    icon: 'ri-flashlight-line',
    title: '最短即日対応',
    desc: '京都府内なら、お電話・LINEからのご相談で最短当日中に駆けつけます。急な不用品回収や引越しにも柔軟に対応可能です。',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20Japanese%20waste%20removal%20team%20working%20quickly%20on%20residential%20street%20in%20Kyoto%2C%20clean%20uniforms%2C%20bright%20natural%20daylight%2C%20efficient%20organized%20work%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background%2C%20high%20detail&width=800&height=600&seq=yoshikawa-reason-01&orientation=landscape',
  },
  {
    num: '02',
    icon: 'ri-hand-heart-line',
    title: '丁寧な作業',
    desc: '遺品整理では、ご遺族のお気持ちに寄り添い、一点一点丁寧に仕分け。近隣への配慮を欠かさず、養生・分別も徹底します。',
    image:
      'https://readdy.ai/api/search-image?query=Careful%20respectful%20Japanese%20workers%20organizing%20personal%20items%20in%20traditional%20tatami%20room%2C%20soft%20natural%20window%20light%2C%20calm%20dignified%20atmosphere%2C%20warm%20muted%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background%2C%20high%20detail&width=800&height=600&seq=yoshikawa-reason-02&orientation=landscape',
  },
  {
    num: '03',
    icon: 'ri-building-2-line',
    title: '不動産・法人対応',
    desc: '不動産会社様の残置物撤去・退去後クリーニング、法人様の産廃回収・機密書類処分まで、継続案件・請求書払いにも対応。',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20Japanese%20real%20estate%20cleanup%20crew%20in%20clean%20apartment%20building%20corridor%2C%20removing%20abandoned%20items%20carefully%2C%20bright%20natural%20light%2C%20professional%20corporate%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=yoshikawa-reason-03&orientation=landscape',
  },
  {
    num: '04',
    icon: 'ri-price-tag-3-line',
    title: '明朗会計',
    desc: '事前お見積り後の追加請求は一切なし。安心の透明価格です。不用品回収・遺品整理ともに、わかりやすい料金体系でご提案します。',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20organized%20price%20list%20and%20professional%20invoice%20on%20wooden%20desk%20with%20calculator%20and%20pen%2C%20bright%20natural%20daylight%2C%20transparent%20honest%20business%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=yoshikawa-reason-04&orientation=landscape',
  },
  {
    num: '05',
    icon: 'ri-recycle-line',
    title: '適正処分・リサイクル',
    desc: '古紙回収・資源回収で培ったリサイクルノウハウを活かし、法令に沿った適正処分を徹底。まだ使えるモノは骨董品買取でお値引きに還元します。',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20Japanese%20recycling%20facility%20with%20neatly%20sorted%20paper%20and%20recyclable%20materials%2C%20workers%20in%20uniform%2C%20clean%20organized%20environment%2C%20warm%20natural%20daylight%2C%20professional%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=yoshikawa-reason-05&orientation=landscape',
  },
  {
    num: '06',
    icon: 'ri-shield-user-line',
    title: '女性・高齢者にも安心',
    desc: '女性スタッフ在籍・身分証提示・京都府内自社車両。プライバシーを厳守した対応で、遺品整理や不用品回収も安心してお任せいただけます。',
    image:
      'https://readdy.ai/api/search-image?query=Friendly%20Japanese%20female%20staff%20member%20in%20clean%20work%20uniform%20talking%20with%20elderly%20customer%20at%20doorway%2C%20warm%20respectful%20atmosphere%2C%20soft%20natural%20light%2C%20trustworthy%20professional%20service%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=yoshikawa-reason-06&orientation=landscape',
  },
];

export const services = [
  {
    tag: '資源リサイクル',
    tagColor: 'bg-secondary-100 text-secondary-900',
    title: '古紙回収',
    desc: '段ボール・新聞・雑誌・オフィス古紙など、あらゆる古紙を回収。分別回収からリサイクルまで一貫対応。法人様の定期回収も承ります。',
    image:
      'https://readdy.ai/api/search-image?query=Neatly%20stacked%20cardboard%20boxes%20and%20newspapers%20in%20a%20clean%20Japanese%20recycling%20facility%2C%20workers%20in%20uniform%20sorting%20paper%20materials%2C%20bright%20natural%20daylight%2C%20organized%20professional%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background%2C%20high%20detail&width=800&height=600&seq=yoshikawa-service-01&orientation=landscape',
    features: ['段ボール・新聞・雑誌', 'オフィス古紙の定期回収', '機密書類の分別', 'リサイクル処理まで一貫'],
  },
  {
    tag: '資源リサイクル',
    tagColor: 'bg-secondary-100 text-secondary-900',
    title: '資源回収',
    desc: 'ペットボトル・缶・ビン・金属類など、資源ゴミの分別回収を徹底。リサイクル率の向上と環境負荷低減に貢献します。',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20organized%20recycling%20facility%20with%20neatly%20sorted%20plastic%20bottles%20cans%20and%20glass%20containers%20in%20separate%20bins%2C%20Japanese%20workers%20in%20uniform%2C%20warm%20natural%20daylight%2C%20professional%20clean%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=yoshikawa-service-02&orientation=landscape',
    features: ['ペットボトル・缶・ビン', '金属類・古布の回収', '分別回収の徹底', '定期回収契約対応'],
  },
  {
    tag: '法人対応',
    tagColor: 'bg-secondary-100 text-secondary-900',
    title: '産業廃棄物収集運搬',
    desc: '京都府認可の産廃許可に基づき、事業ゴミ・建設廃材・汚泥・廃プラなど幅広い産業廃棄物の収集運搬に対応。マニフェスト発行可能。',
    image:
      'https://readdy.ai/api/search-image?query=Industrial%20waste%20collection%20truck%20at%20a%20clean%20Japanese%20construction%20site%2C%20professional%20workers%20loading%20sorted%20waste%20materials%2C%20warm%20natural%20daylight%2C%20organized%20professional%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background%2C%20high%20detail&width=800&height=600&seq=yoshikawa-service-03&orientation=landscape',
    features: ['マニフェスト対応', '建設廃材・汚泥・廃プラ', '定期回収契約OK', '法令遵守の適正処理'],
  },
  {
    tag: '法人・店舗対応',
    tagColor: 'bg-secondary-100 text-secondary-900',
    title: '一般廃棄物回収',
    desc: '店舗・事務所・飲食店などから出る事業系一般廃棄物を回収。地域に密着した迅速な対応で、法人様の廃棄物処理をサポートします。',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20white%20light%20commercial%20waste%20collection%20truck%20parked%20in%20front%20of%20a%20Japanese%20restaurant%2C%20professional%20workers%20in%20uniform%2C%20warm%20natural%20daylight%2C%20reliable%20trustworthy%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=yoshikawa-service-04&orientation=landscape',
    features: ['事業系一般廃棄物の回収', '店舗・飲食店対応', '定期回収プラン', '分別指導もサポート'],
  },
  {
    tag: '家庭向け',
    tagColor: 'bg-secondary-100 text-secondary-900',
    title: '不用品回収',
    desc: '家具・家電・大型ゴミからお部屋まるごとまで、1点から丸ごとまで対応可能。軽トラ・2トン・4トンとご依頼量に応じた最適プランをご提案します。',
    image:
      'https://readdy.ai/api/search-image?query=Japanese%20uniformed%20removal%20workers%20carefully%20carrying%20furniture%20out%20of%20a%20traditional%20Kyoto%20home%20entrance%2C%20clean%20warm%20natural%20light%2C%20professional%20trustworthy%20atmosphere%2C%20neutral%20warm%20tones%2C%20editorial%20photography%20style%2C%20simple%20clean%20background%2C%20high%20detail&width=800&height=600&seq=yoshikawa-service-05&orientation=landscape',
    features: ['家具・家電1点から', '引越しに伴う一括回収', '大型ゴミ・粗大ゴミ', '分別・搬出込み'],
  },
  {
    tag: '家族向け',
    tagColor: 'bg-secondary-100 text-secondary-900',
    title: '遺品整理',
    desc: 'ご遺族様に寄り添う遺品整理。貴重品・思い出の品の仕分け、供養品の合同供養、形見分けまで一貫サポートいたします。',
    image:
      'https://readdy.ai/api/search-image?query=Respectful%20Japanese%20estate%20cleanup%20service%20workers%20gently%20sorting%20personal%20items%20on%20tatami%20mat%20in%20a%20quiet%20Kyoto%20room%2C%20soft%20natural%20window%20light%2C%20calm%20dignified%20atmosphere%2C%20warm%20muted%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=yoshikawa-service-06&orientation=landscape',
    features: ['貴重品・書類の仕分け', '合同供養サービス', '遠方のご遺族対応', '遺品整理士在籍'],
  },
  {
    tag: '法人対応',
    tagColor: 'bg-secondary-100 text-secondary-900',
    title: '機密書類処分',
    desc: '個人情報や機密文書を安全かつ確実に溶解処理。オフィス・医療機関・士業の先生方まで、機密保持を徹底した出張回収にも対応します。',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20secure%20document%20shredding%20service%20in%20a%20clean%20Japanese%20office%2C%20workers%20handling%20confidential%20files%20into%20secure%20bins%2C%20warm%20natural%20daylight%2C%20trustworthy%20professional%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=yoshikawa-service-07&orientation=landscape',
    features: ['溶解処理で完全処分', 'ダンボールごと回収OK', '処理証明書の発行', 'オフィス出張回収'],
  },
  {
    tag: '買取サービス',
    tagColor: 'bg-secondary-100 text-secondary-900',
    title: '骨董品買取',
    desc: '古美術・骨董品・茶道具・掛軸・陶磁器など幅広く査定買取。遺品整理やお片付けの際に出たお品も、その場でしっかり査定いたします。',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20Japanese%20antique%20appraiser%20examining%20vintage%20ceramics%20and%20ornaments%20on%20a%20clean%20wooden%20table%2C%20warm%20soft%20natural%20light%2C%20refined%20respectful%20atmosphere%2C%20warm%20muted%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background%2C%20high%20detail&width=800&height=600&seq=yoshikawa-service-08&orientation=landscape',
    features: ['骨董品・古美術全般', '茶道具・掛軸・陶磁器', '遺品整理時の出張査定', 'その場で買取代金のお支払い'],
  },
];

export const pricingPlans = [
  {
    label: '少量・単身向け',
    title: '軽トラック',
    price: '20,000',
    size: '軽トラック 1台分',
    load: '約1〜1.5畳分',
    features: ['1Kのお部屋の片づけ', '冷蔵庫+洗濯機など家電数点', '粗大ゴミの一括処分'],
    highlight: false,
  },
  {
    label: 'ファミリー・遺品整理',
    title: '2トントラック積み放題',
    price: '35,000',
    size: '2トントラック 1台分',
    load: '約3〜4畳分',
    features: ['1LDK〜2DKの片づけ', '遺品整理の一括対応', '引越しに伴う不用品処分'],
    highlight: true,
    badge: '人気No.1プラン',
  },
  {
    label: '戸建て・法人向け',
    title: '4トントラック積み放題',
    price: '50,000',
    size: '4トントラック 1台分',
    load: '約6〜8畳分',
    features: ['戸建てまるごと片づけ', 'ゴミ屋敷清掃', 'オフィス移転・残置物撤去'],
    highlight: false,
  },
];

export const flowSteps = [
  {
    step: '01',
    icon: 'ri-phone-line',
    title: 'お問い合わせ',
    desc: '電話またはLINEにて、お品目・お部屋の状況・ご希望日時をお知らせください。京都府内なら即日訪問も可能です。',
  },
  {
    step: '02',
    icon: 'ri-file-list-3-line',
    title: '無料お見積り',
    desc: '現地訪問または写真見積りで、正確なお見積り金額をご提示。ご不明点はこの段階で全て解消いただけます。',
  },
  {
    step: '03',
    icon: 'ri-calendar-check-line',
    title: '作業日のご予約',
    desc: 'お見積りにご納得いただけた場合のみ、作業日を確定。キャンセル料は作業前日までいただきません。',
  },
  {
    step: '04',
    icon: 'ri-truck-line',
    title: '作業当日',
    desc: '経験豊富なスタッフが京都府内自社車両で訪問。養生・分別・搬出まで、近隣にも配慮した丁寧な作業を行います。',
  },
  {
    step: '05',
    icon: 'ri-recycle-line',
    title: '適正処分・リサイクル',
    desc: '京都府の産廃基準に沿った適正処分。買取可能な品目は査定し、その場でお値引きさせていただきます。',
  },
  {
    step: '06',
    icon: 'ri-wallet-3-line',
    title: 'お支払い・完了報告',
    desc: '現金・銀行振込・法人様は請求書払いに対応。写真付き作業報告書も無料でお渡しいたします。',
  },
];

export const cases = [
  {
    type: '不用品回収',
    location: '京都市中京区',
    time: '作業時間 約1.5時間',
    title: '1Kマンションの引越しに伴う一括回収',
    desc: '冷蔵庫・洗濯機・電子レンジ・カラーボックス・ゴミ袋8個など、単身引越しに伴う不用品を軽トラック1台で回収。当日ご依頼から3時間以内に作業完了。',
    price: '20,000',
    image:
      'https://readdy.ai/api/search-image?query=Neatly%20organized%20clean%20Japanese%20one%20room%20apartment%20interior%20after%20professional%20junk%20removal%2C%20polished%20wooden%20floor%2C%20soft%20window%20light%2C%20warm%20neutral%20tones%2C%20clean%20restored%20room%2C%20editorial%20photography%2C%20simple%20clean%20background%2C%20high%20detail&width=800&height=600&seq=yoshikawa-case-01&orientation=landscape',
  },
  {
    type: '遺品整理',
    location: '京都市左京区',
    time: '作業時間 約6時間',
    title: '戸建ての遺品整理・合同供養',
    desc: 'ご遺族様が遠方在住のため、鍵預かりで対応。仏具・写真の合同供養、貴重品の別途仕分け、簡易清掃までワンストップ。骨董品の査定買取も実施。',
    price: '185,000',
    image:
      'https://readdy.ai/api/search-image?query=Peaceful%20tidy%20Japanese%20traditional%20room%20with%20tatami%20mat%20after%20estate%20cleanup%20service%2C%20soft%20natural%20light%20through%20shoji%20window%2C%20calm%20warm%20neutral%20tones%2C%20dignified%20atmosphere%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=yoshikawa-case-02&orientation=landscape',
  },
  {
    type: '産業廃棄物収集運搬',
    location: '京都府亀岡市',
    time: '作業時間 約4時間',
    title: '建設現場からの建設廃材一括回収',
    desc: '小規模解体現場からの木材・コンクリート片・廃プラスチックを4トントラックで回収。マニフェスト発行、産廃基準に沿った適正処理を実施。',
    price: '120,000',
    image:
      'https://readdy.ai/api/search-image?query=Construction%20waste%20collection%20at%20a%20clean%20Japanese%20demolition%20site%2C%20professional%20workers%20loading%20sorted%20debris%20into%20truck%2C%20warm%20natural%20daylight%2C%20organized%20professional%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=yoshikawa-case-03&orientation=landscape',
  },
  {
    type: '機密書類処分',
    location: '京都市下京区',
    time: '作業時間 約2時間',
    title: 'オフィス移転に伴う機密書類の一括溶解処分',
    desc: '法律事務所からのご依頼。ダンボール30箱分の機密文書を溶解処分。処理証明書を発行し、情報漏洩リスクゼロで完了。',
    price: '45,000',
    image:
      'https://readdy.ai/api/search-image?query=Secure%20document%20disposal%20service%20in%20a%20professional%20Japanese%20office%20setting%2C%20confidential%20files%20being%20processed%20into%20secure%20bins%2C%20clean%20organized%20atmosphere%2C%20warm%20neutral%20tones%2C%20trustworthy%20professional%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=yoshikawa-case-04&orientation=landscape',
  },
  {
    type: '古紙回収',
    location: '京都市北区',
    time: '作業時間 約3時間',
    title: 'オフィスビルの定期古紙回収',
    desc: '5階建てオフィスビルの各フロアから段ボール・シュレッダー古紙を定期回収。月2回のスケジュールで安定運用中。分別指導も併せてサポート。',
    price: '15,000',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20paper%20recycling%20collection%20at%20a%20clean%20modern%20Japanese%20office%20building%2C%20workers%20collecting%20neatly%20stacked%20cardboard%20boxes%2C%20warm%20natural%20daylight%2C%20organized%20efficient%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=yoshikawa-case-05&orientation=landscape',
  },
  {
    type: '骨董品買取',
    location: '京都府宇治市',
    time: '査定時間 約2時間',
    title: '遺品整理に伴う骨董品・茶道具の出張査定買取',
    desc: 'ご自宅に伺い、掛軸・茶碗・花入・香炉など約30点を査定。遺品整理と合わせてその場で買取代金をお支払いし、整理費用の一部に充当。',
    price: '買取代金 180,000',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20Japanese%20antique%20appraiser%20examining%20vintage%20tea%20ceremony%20utensils%20and%20scrolls%20in%20a%20traditional%20Japanese%20room%2C%20warm%20soft%20natural%20light%2C%20refined%20respectful%20atmosphere%2C%20warm%20muted%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=yoshikawa-case-06&orientation=landscape',
  },
];

export const voices = [
  {
    name: 'T.S 様',
    location: '京都市北区',
    age: '40代女性',
    service: '遺品整理',
    comment:
      '「母の遺品整理をお願いしました。写真や手紙の仕分けまで一つひとつ確認してくださり、涙が出るほど丁寧でした。骨董品の査定もしていただけて助かりました。」',
    initial: 'T',
  },
  {
    name: 'K.N 様',
    location: '京都市山科区',
    age: '30代男性',
    service: '不用品回収',
    comment:
      '「急な引越しで当日夜にお願いしたのに、すぐ来てくれました。追加料金なしで見積り通り。不用品回収でここまで早いのは初めてでした。」',
    initial: 'K',
  },
  {
    name: 'H不動産様',
    location: '京都市下京区',
    age: '法人',
    service: '機密書類処分',
    comment:
      '「オフィス移転時の機密書類処分で依頼しました。溶解処理で安心、処理証明書もすぐ発行していただけたので非常に助かりました。」',
    initial: 'H',
  },
  {
    name: 'M.Y 様',
    location: '京都府宇治市',
    age: '60代女性',
    service: '骨董品買取',
    comment:
      '「遺品整理のついでに骨董品を見ていただきました。思っていたより高値で買い取っていただけて、整理費用に充てることができました。」',
    initial: 'M',
  },
  {
    name: 'S工務店様',
    location: '京都府亀岡市',
    age: '法人',
    service: '産業廃棄物収集運搬',
    comment:
      '「小規模な解体現場からの産廃回収でお世話になっています。マニフェスト対応と柔軟な回収スケジュールで、現場責任者としてとても助かっています。」',
    initial: 'S',
  },
  {
    name: 'A.K 様',
    location: '京都市西京区',
    age: '50代男性',
    service: '遺品整理',
    comment:
      '「父が亡くなり、遠方から手配する必要がありました。鍵預かりから最後の確認まで、全部LINEでやり取りできて助かりました。ありがとうございました。」',
    initial: 'A',
  },
];

export const faqItems = [
  {
    question: '京都府外の対応も可能ですか?',
    answer:
      '基本の対応エリアは京都府全域ですが、大阪府・滋賀県の隣接エリアはご相談に応じます。まずはお問い合わせください。',
  },
  {
    question: '即日対応は本当に可能ですか?',
    answer:
      'はい、京都府内であれば、お電話・LINEからのご相談で最短当日中に駆けつけることも可能です。ただし、混雑状況により翌日になる場合もございます。',
  },
  {
    question: '見積りは無料ですか?',
    answer:
      'はい、お見積りは完全無料です。現地訪問またはLINEでの写真見積りのどちらも料金はいただきません。',
  },
  {
    question: '遺品整理の際、貴重品や思い出の品はどうなりますか?',
    answer:
      'ご遺族様のご意向を確認し、貴重品・証明書類・思い出の品はすべて安全に仕分けし、お返しいたします。不要なものは合同供養または処分をご提案いたします。骨董品は買取査定も可能です。',
  },
  {
    question: '料金は追加請求されませんか?',
    answer:
      'お見積り後の追加請求は一切ありません。ただし、作業当日に追加品目や階段搬出などが発生した場合は、事前にお知らせし了承を得た上で対応いたします。',
  },
  {
    question: '支払い方法は何がありますか?',
    answer:
      '現金・銀行振込に対応しております。法人様・不動産会社様は請求書払い（後払い）も可能です。',
  },
  {
    question: '機密書類はどのように処分されますか?',
    answer:
      '個人情報や機密文書は溶解処理により完全に処分いたします。ダンボールごと回収可能で、処理証明書も発行いたしますので、情報漏洩の心配はございません。',
  },
  {
    question: '産業廃棄物のマニフェストは発行してもらえますか?',
    answer:
      'はい、京都府の産業廃棄物収集運搬業の許可業者として、マニフェストを発行可能です。法令遵守のもと適正な収集運搬を行います。',
  },
];

export const companyInfo = [
  { label: '会社名', value: '吉川産業' },
  { label: '代表者', value: '吉川 晃史' },
  {
    label: '所在地',
    value: '〒606-8222 京都府京都市左京区田中上玄京町53-1',
  },
  { label: '電話番号', value: '0120-219-620' },
  {
    label: '事業内容',
    value: '古紙回収 / 資源回収 / 産業廃棄物収集運搬 / 一般廃棄物回収 / 不用品回収 / 遺品整理 / 機密書類処分 / 骨董品買取',
  },
  { label: '設立', value: '1975年4月' },
  { label: '対応エリア', value: '京都府全域' },
  { label: '営業時間', value: '9:00〜17:00' },
  { label: '定休日', value: '年中無休' },
  {
    label: '許可番号',
    value: '京都府産業廃棄物収集運搬業 許可番号:02600116177 / 一般廃棄物収集運搬業 許可番号:222号',
  },
];

export const serviceAreas = ['京都市', '宇治市', '亀岡市', '長岡京市', '向日市', '八幡市', '城陽市', '京田辺市', '木津川市', '久御山町'];

export const navLinks = [
  { label: '選ばれる理由', href: '#reasons' },
  { label: 'サービス', href: '#services' },
  { label: '料金目安', href: '#pricing' },
  { label: '作業の流れ', href: '#flow' },
  { label: '作業事例', href: '#cases' },
  { label: 'お客様の声', href: '#voices' },
  { label: 'よくある質問', href: '#faq' },
  { label: '会社概要', href: '#company' },
];

export const footerServiceLinks = [
  '古紙回収',
  '資源回収',
  '産業廃棄物収集運搬',
  '一般廃棄物回収',
  '不用品回収',
  '遺品整理',
  '機密書類処分',
  '骨董品買取',
];

export const footerContentLinks = [
  { label: '選ばれる理由', href: '#reasons' },
  { label: '料金目安', href: '#pricing' },
  { label: '作業の流れ', href: '#flow' },
  { label: '作業事例', href: '#cases' },
  { label: 'よくある質問', href: '#faq' },
];

export const footerCompanyLinks = [
  { label: '会社概要', href: '#company' },
  { label: 'お問い合わせ', href: '#contact' },
];